import { styled, TextField } from "@mui/material";

export const SearchField = styled(TextField)({
  width: "100%",
  borderRadius: "8px",
  fontSize: "0.875rem",
  "& .MuiOutlinedInput-root": {
    height: "100%",
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {
      border: "none",
    },
    "&.Mui-focused fieldset": {
      border: "none",
    },
  },
});
